var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.80859,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#010101",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3086 15.9167H13.2317M13.2317 15.9167C13.2317 16.5355 12.9885 17.129 12.5558 17.5666C12.123 18.0042 11.536 18.25 10.924 18.25C10.3119 18.25 9.72497 18.0042 9.29219 17.5666C8.85942 17.129 8.61629 16.5355 8.61629 15.9167C8.61629 15.2978 8.85942 14.7043 9.29219 14.2668C9.72497 13.8292 10.3119 13.5833 10.924 13.5833C11.536 13.5833 12.123 13.8292 12.5558 14.2668C12.9885 14.7043 13.2317 15.2978 13.2317 15.9167ZM14.3855 10.0833H6.30859M14.3855 10.0833C14.3855 10.7022 14.6286 11.2957 15.0614 11.7332C15.4942 12.1708 16.0812 12.4167 16.6932 12.4167C17.3052 12.4167 17.8922 12.1708 18.325 11.7332C18.7578 11.2957 19.0009 10.7022 19.0009 10.0833C19.0009 9.46449 18.7578 8.871 18.325 8.43342C17.8922 7.99583 17.3052 7.75 16.6932 7.75C16.0812 7.75 15.4942 7.99583 15.0614 8.43342C14.6286 8.871 14.3855 9.46449 14.3855 10.0833Z",
    stroke: "#010101",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e51a9df195f0c94996aa67650121b9df.svg";
export { ForwardRef as ReactComponent };